const NOT_AVAILABLE_MESSAGE =
  "The AI assistant is not available at this moment, please try it later or refer to the <a href='https://www.bequant.com/docs/' target='_blank'> documentation site </a> for more information.";

export class GeminiClient {
  constructor(hardwareId = "", url = "", secret = "", version = "") {
    this.hardwareId = hardwareId;
    this.secret = secret;
    this.url = url;
    //this.url = "http://127.0.0.1:5001/bqn-chatbox/us-central1/BRANCH_FUNC_NAME";
    //this.url = "https://us-central1-bqn-chatbox.cloudfunctions.net/geminiSendContent_jarroyo_R5_0_3703"
    this.version = version;
  }

  async sendMessage(message) {
    let response;

    try {
      response = await fetch(
        `${this.url}?hardwareId=${encodeURIComponent(
          this.hardwareId,
        )}&version=${encodeURIComponent(
          this.version,
        )}&mode=${encodeURIComponent(message.mode)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.secret,
          },
          body: JSON.stringify({
            question: message.question,
            history: message.history,
            location: location.pathname,
            managementIpAddress: location.host,
            data: message.data,
            urls: message.urls,
            context: message.context,
          }),
        },
      );
    } catch (err) {
      throw `${NOT_AVAILABLE_MESSAGE} ${err}`;
    }

    if (!response.ok) {
      throw `${NOT_AVAILABLE_MESSAGE} HTTP error! status: ${response.status}`;
    }

    try {
      return (await response.json()).text;
    } catch (err) {
      throw `${NOT_AVAILABLE_MESSAGE} ${err}`;
    }
  }
}
